import {useDispatch, useSelector} from 'react-redux';
import {useNavigate} from 'react-router-dom';
import {useEffect, useState} from 'react';
import {HEADER_DATA} from '../../Employees/Model/Models';
import {GetHeaders, UpdateHeaders} from '../../../../../reduxToolkit/headers/HeadersApi';
import routes from '../../../../../Routes/routes';

const AddUpdateHeadersApp = () => {

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const { headersList } = useSelector((state) => state.headersSlice);
    const DEV = useSelector((state) => state?.CommonsSlice?.development);
    const { permission } = useSelector((state) => state.authenticatioauthennSlice);

    const [headerObj, setHeaderObj] = useState({...HEADER_DATA});

    const [contractorId, setContractorId] = useState(sessionStorage.getItem('contractorId'));
    const [supplierId, setSupplierId] = useState(sessionStorage.getItem('providerId'));

    useEffect(() => {
        dispatch(GetHeaders())
            .unwrap()
            .then(({ data: { data } }) => {
                setHeaderObj({
                    header1: data?.header1 || 'header_1',
                    header2: data?.header2 || 'header_2',
                    header3: data?.header3 || 'header_3',
                    header4: data?.header4 || 'header_4',
                    header5: data?.header5 || 'header_5',
                    header6: data?.header6 || 'header_6',
                    header7: data?.header7 || 'header_7',
                    header8: data?.header8 || 'header_8',
                    header9: data?.header9 || 'header_9',
                    header10: data?.header10 || 'header_10',
                    header11: data?.header11 || 'header_11',
                    header12: data?.header12 || 'header_12',
                    header13: data?.header13 || 'header_13',
                    header14: data?.header14 || 'header_14',
                    header15: data?.header15 || 'header_15',
                });
            });
    }, []);

    const handleClearFields = () => {
        setHeaderObj({...HEADER_DATA});
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setHeaderObj({ ...headerObj, [name]: value });
    };

    const handleHeaders = () => {
        headerObj.id = headersList?.id;
        headerObj.company = {
            id: headersList?.company?.id,
        };
        dispatch(UpdateHeaders(headerObj)).then(() => {
            navigate(routes.headers.headers);
        });
    };

    return {
        handleChange,
        handleHeaders,
        handleClearFields,
        dispatch,
        navigate,
        headersList,
        DEV,
        permission,
        headerObj,
        setHeaderObj,
        contractorId,
        supplierId,
    }

}

export default AddUpdateHeadersApp;
